import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.promise.finally.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/**
 * A service to help with matrix event management
 */


export var MatrixEventService = /*#__PURE__*/function () {
  function MatrixEventService(httpClient) {
    _classCallCheck(this, MatrixEventService);

    this.httpClient = httpClient;
    this.cachedPromises = new Map();
  }
  /**
   * Get the latest state from the matrix node
   *
   * @param accessToken
   * @param options
   */


  _createClass(MatrixEventService, [{
    key: "sync",
    value: function sync(accessToken, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.withCache('sync', function () {
                  return _this.httpClient.get('/sync', {
                    timeout: options ? options.pollingTimeout : undefined,
                    since: options ? options.syncToken : undefined
                  }, {
                    accessToken: accessToken
                  });
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Send a message to a room
     *
     * @param accessToken
     * @param room
     * @param content
     * @param txnId
     */

  }, {
    key: "sendMessage",
    value: function sendMessage(accessToken, roomId, content, txnId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  return _this2.scheduleEvent({
                    accessToken: accessToken,
                    roomId: roomId,
                    type: 'm.room.message',
                    content: content,
                    txnId: txnId,
                    onSuccess: resolve,
                    onError: reject
                  });
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
    /**
     * Schedules an event to be sent to the node
     *
     * @param event
     */

  }, {
    key: "scheduleEvent",
    value: function scheduleEvent(event) {
      // TODO: actual scheduling
      this.sendEvent(event);
    }
    /**
     * Send an event to the matrix node
     *
     * @param scheduledEvent
     */

  }, {
    key: "sendEvent",
    value: function sendEvent(scheduledEvent) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var roomId, type, txnId, content, accessToken, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                roomId = scheduledEvent.roomId, type = scheduledEvent.type, txnId = scheduledEvent.txnId, content = scheduledEvent.content, accessToken = scheduledEvent.accessToken;
                _context3.prev = 1;
                _context3.next = 4;
                return this.httpClient.put("/rooms/".concat(encodeURIComponent(roomId), "/send/").concat(type, "/").concat(encodeURIComponent(txnId)), content, {
                  accessToken: accessToken
                });

              case 4:
                response = _context3.sent;
                scheduledEvent.onSuccess(response);
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);
                scheduledEvent.onError(_context3.t0);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 8]]);
      }));
    }
    /**
     * Check the cache when interacting with the Matrix node, if there is an already ongoing call for the specified key, return its promise instead of duplicating the call.
     *
     * @param key
     * @param promiseProvider
     */

  }, {
    key: "withCache",
    value: function withCache(key, promiseProvider) {
      var _this3 = this;

      var promise = this.cachedPromises.get(key);

      if (!promise) {
        promise = promiseProvider().finally(function () {
          _this3.cachedPromises.delete(key);
        });
        this.cachedPromises.set(key, promise);
      }

      return promise;
    }
  }]);

  return MatrixEventService;
}();